// axiosInstance.js
import axios from 'axios';
import { toast } from "react-toastify";
import { baseUrl, authToken } from "../actions";

// Create a custom axios instance
const axiosInstance = axios.create({
    baseURL: baseUrl,
    timeout: 30000, // 30seconds
});

axiosInstance.interceptors.request.use(
    (config) => {
        // Add Authorization header if token exists
        if (authToken) {
            config.headers['Authorization'] = `Bearer ${authToken}`;
        }

        // You can also log or modify headers here
        ///console.log(`[Request] ${config.method?.toUpperCase()} ${config.url}`, config);

        return config;
    },
    (error) => {
        // Handle request error
        console.error('[Request Error]', error);
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle response errors globally
        console.log("error ...........", error);
        if (error.response) {
            console.error(`[Response Error] ${error.response.status}`, error.response.data);

            if (error.response.status === 401) {
                localStorage.removeItem('authToken');
                localStorage.removeItem('userRole');
                localStorage.clear();
                window.location.href = '/login';
            } else if (error.response.status === 500) {
                toast.error("Oops! Something went wrong. Please try again later");
            } else if (error.response.status === 400) {
                toast.error(error.response.data.data || error.response.data.message);
            }
        } else {
            console.error('[Network Error]', error);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
